
/*
Custom Megamenu for Ruby's Organics Shopify by TSW
Author: Deepak Kamat
*/

var megaMenuInitialized = false;
var megamenuSwiperStarted = false;

function startMegamenuSwiper() {
    if (megamenuSwiperStarted || !$('.js-megamenu-slides').length) {
        return;
    }
    if (typeof window.loadSwiper !== 'function') {
        return;
    }

    megamenuSwiperStarted = true;

    window.loadSwiper().then(function () {
        new Swiper('.js-megamenu-slides', {
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });
}

var tswMegamenu = {
    toggleMenu: function( e, elm ) {
        $megamenuouter = $( '.tsw-megamenu-wrapper-mobile-outer' );

        if ( $megamenuouter.hasClass('tsw-megamenu-open') ) {
            tswMegamenu.closeMenu(e, elm);
        } else {
            tswMegamenu.openMenu(e, elm);
        }
    },
    openMenu: function( e, elm ) {
        $megamenuouter = $( '.tsw-megamenu-wrapper-mobile-outer' );
        $megamenuouter.addClass('tsw-megamenu-open');
        $("body").addClass("tsw-megamenu-active");
        startMegamenuSwiper();
    },
    closeMenu: function( e, elm ) {
        $megamenuouter = $( '.tsw-megamenu-wrapper-mobile-outer' );
        $megamenuouter.removeClass('tsw-megamenu-open');
        $("body").removeClass("tsw-megamenu-active");
    }
}

function initializedTSWMegamenu(){
            if ( megaMenuInitialized ) {
              return 0;
            }

            megaMenuInitialized = true;
  
            // TSW Megamenu Drawer
            $(document).on('click', '[data-tsw-megamenudrawer]', function( e ){
                e.preventDefault();
                tswMegamenu.toggleMenu( e, this );
            });
            $(document).on('click', '.tsw-mobile-close', function( e ){
                e.preventDefault();
                tswMegamenu.closeMenu( e, this );
            });

            // Toggle mobile menu dropdowns
            $(document).on('click', '.tsw-menu-items-group .megamenu-collection-top-link.tsw-megamenu-has-children', function( e ){
                $('.search-box-wrapper-outer [type="search"]').blur();
                e.preventDefault();

                $parentGroup = $(this).parents('.tsw-menu-items-group');
                if ( $parentGroup.hasClass('menu-open') ) {
                  $parentGroup.removeClass('menu-open');
                } else {
                  $parentGroup.addClass('menu-open');
                }
            });

            // Automatic columns in desktop
            let numberofcolumns = $('.tsw-megamenu-wrapper-desktop .collections-column .tsw-menu-col').length;
            if ( numberofcolumns ) {
                $('.tsw-megamenu-wrapper-desktop .collections-column').addClass('collections-columns-' + numberofcolumns);
            }


            $(document).one('mouseenter focusin', '.tsw-megamenu-wrapper-desktop', startMegamenuSwiper);
}

function whenJQueryReady(fn) {
    if (typeof jQuery !== 'undefined') {
        fn();
        return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
        if (typeof jQuery !== 'undefined' || ++attempts > 80) {
            clearInterval(timer);
            if (typeof jQuery !== 'undefined') {
                fn();
            }
        }
    }, 50);
}

function bootTSWMegamenu() {
    whenJQueryReady(initializedTSWMegamenu);
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootTSWMegamenu);
} else {
    bootTSWMegamenu();
}
